import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import * as React from 'react';
import './datepicker.css';


export default function CustomDateRangePicker({ handleSetDateRange, value, open, close, isOpen, startDate, endDate, style2 }) {

    return (
        <div>

            <div className="d-flex align-items-center date-range-container" onClick={() => open()}>
                {
                    style2 ?
                        <div className='d-flex justify-content-between w-100'>
                            <div>{startDate} - {endDate}</div>
                            <div style={{ borderLeft: '1px solid #0000002D', paddingLeft: 10 }}><i className="ri-expand-up-down-line" /></div>
                        </div>
                        :
                        <div className='d-flex justify-content-between w-100'>
                             <div>{startDate} - {endDate}</div> <i className="ri-expand-up-down-line"></i>
                        </div>
                }
            </div>
            <DateRangePicker
                onChange={(e) => handleSetDateRange(e)}
                value={value === '' ? null : value}
                calendarIcon={<i className="ri-calendar-line font-size-18" />}
                isOpen={isOpen}
                closeCalendar={() => close()}
                shouldCloseCalendar={({ reason }) => {
                    if (reason === 'outsideAction' || reason === 'select') {
                        close();
                    }
                }}
            />

        </div>
    );
}
